// extracted by mini-css-extract-plugin
export default {"ul":"Navbar_ul__BjPPw","li":"Navbar_li__CGkXQ"};